module.exports = __webpack_public_path__ + "ccca32dd7a6e382ce6eb76dea7f6ce8a.png";